/**
 * Replacing type name E to J
 */

export const Replacetype = function () {
	// if (typeof hoge !== "nameTable") {
	const typeReplace = document.querySelectorAll(".type_replace:not(.replaced)");
	if (typeReplace.length > 0) {
		// type_replace blocks
		typeReplace.forEach((type) => {
			const original = type.innerText;
			console.log(original);
			const labels = original.split("/");
			const replaced = [];
			labels.forEach((label) => {
				// nameTable.forEach( (table) => {
				// 	if (table.ename === label) {
				// 		replaced.push(table.jname);
				// 	}
				// });
				nameTable.some((table) => {
					if (table.ename === label) {
						replaced.push(table.jname);// get Japanese word
						return true; // break
					}
					return false; // continue
				});
			});
			type.innerText = replaced.join(", ");
			type.classList.add("replaced");
		})
	}
	// }
}
